import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import { Toast } from 'vant'
import ErrorView from '@/views/Error.vue'
import { agentDefinitions } from '@/views/assistant/datasource/agentDefinitions'
import { t } from '@/i18n'
import beforeEach from './beforeEach'
import afterEach from './afterEach'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Index',
    component: () => import('@/views/Index.vue'),
  },
  // {
  //   path: '/equipment/home',
  //   name: 'EquipmentOldHome',
  //   meta: {
  //     title: t('home'),
  //     showBack: false
  //   }
  // },
  // todo 先兼容一个版本，等 swap 更新后再调整为下方配置
  // {
  //   path: '/equipment/home',
  //   redirect: '/equipment/powerswap/home'
  // },
  // {
  //   // 为后续 swap 项目统一路由做准备
  //   path: '/equipment/powerswap/home',
  //   name: 'EquipmentHome',
  //   meta: {
  //     title: t('home'),
  //     showBack: false
  //   }
  // },
  {
    // 此配置仅用于标题变更及其他小部分逻辑，不用于实际页面加载
    path: '/equipment',
    name: 'deviceManagement',
    component: () => import('@/views/Equipment.vue'),
    meta: {
      title: t('deviceManagement'),
      showBack: false,
    },
  },
  // {
  //   // 此配置仅用于标题变更及其他小部分逻辑，不用于实际页面加载
  //   path: '/equipment/powerswap/list',
  //   name: 'EquipmentPowerswapList',
  //   meta: {
  //     title: t('powerSwap'),
  //     showBack: false
  //   }
  // },
  // {
  //   // 此配置仅用于标题变更及其他小部分逻辑，不用于实际页面加载
  //   path: '/equipment/powercharger/list',
  //   name: 'EquipmentPowerchargerList',
  //   meta: {
  //     title: t('powerCharger'),
  //     showBack: false
  //   }
  // },
  // {
  //   // 此配置仅用于标题变更及其他小部分逻辑，不用于实际页面加载
  //   path: '/equipment/powercharger/group-mgt/list',
  //   name: 'EquipmentPowerchargerGroupMgtList',
  //   meta: {
  //     title: t('powerChargerGroup'),
  //     showBack: false
  //   }
  // },

  {
    path: '/workbench',
    name: 'workbench',
    meta: {
      title: t('workbench'),
      showBack: false,
    },
    component: () => import('@/views/workbench/index.vue'),
  },
  {
    // 助手分流页：OCC 卡跳 OCC 子应用页（pushState 交给 qiankun），
    // 提效助理卡跳主应用助手页
    path: '/agent',
    name: 'AgentSelect',
    meta: {
      title: '选择智能助手',
      showBack: false,
    },
    component: () => import('@/views/agent/select.vue'),
  },
  {
    // /assistant 无参访问：落到注册表默认 agent，避免无匹配白屏；
    // 对象式 redirect 透传 query（如 ?ui=mobile），防形态参数经无参入口被吞
    path: '/assistant',
    redirect: (to) => ({ name: 'Assistant', params: { agentId: agentDefinitions[0].id }, query: to.query }),
  },
  {
    // 飞书 OAuth 回调（纯页面）：必须排在 /assistant/:agentId 之前，
    // 否则会被动态段吞掉
    path: '/assistant/feishu/callback',
    name: 'AssistantFeishuCallback',
    meta: {
      title: '飞书授权',
      showBack: false,
    },
    component: () => import('@/views/assistant/pages/FeishuOAuthCallback.vue'),
  },
  {
    // 通用 Agent 助手页（纯页面：meta.purePage 由 beforeEach 按前缀标记，
    // Layout 据此隐藏 HeaderNav 与菜单）
    path: '/assistant/:agentId',
    name: 'Assistant',
    meta: {
      title: '智能助手',
      showBack: false,
    },
    component: () => import('@/views/assistant/index.vue'),
  },
  {
    path: '/open-app',
    name: 'OpenApp',
    component: () => import('@/views/OpenApp.vue'),
  },
  {
    path: '/error',
    name: 'Error',
    meta: {
      title: 'PowerGO',
      showBack: true,
    },
    // 主应用error页面不能懒加载，因为直接进入其他子应用error页面→然后created里面跳转（或者
    // beforeEach等任何跳转）到主应用的error页面时，懒加载会导致主应用的error页面显示不了
    component: ErrorView,
  },
  {
    path: '/500',
    name: '500',
    meta: {
      title: '500 ERROR!',
    },
    component: () => import('@/views/500.vue'),
  },
]

export function genRouter() {
  const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
  })

  router.beforeEach(beforeEach)
  router.afterEach(afterEach)

  // 懒加载路由的 chunk 在低版本 iOS 上可能因语法不兼容执行失败（如 /assistant、
  // /agent 的 copilot 渲染链），也可能因发版后旧 HTML 引用已下线的旧 chunk 而 404。
  // 兜底：清掉挂住的 loading 并提示，避免导航卡死；不做自动刷新（低版本 iOS
  // 刷新也救不回，避免刷新循环），其余页面不受影响
  router.onError((error) => {
    console.error('[router] 路由加载失败:', error)
    Toast.clear()
    Toast.fail('页面加载失败，请升级系统或浏览器后重试')
  })

  return router
}
